import { VERCEL_BLOB_PRELOAD_BOOTSTRAP_GATE_URLS } from '../constants/vercelBlobPreloadUrls'

/** Must match `public/sw.js` `message` handler for `ECLIPSERA_PRECACHE_BLOB_GATE`. */
export const ECLIPSERA_PRECACHE_BLOB_GATE_MSG = 'ECLIPSERA_PRECACHE_BLOB_GATE' as const

/**
 * Ask the active (or installing) service worker to fill Cache Storage with the same **gate** bootstrap URLs
 * the first-load bar warms (TexturePacker atlas pairs excluded). Mirrors first-visit vs PWA install cache behavior.
 */
export function postBlobGatePrecacheToServiceWorker(
  registration: ServiceWorkerRegistration | undefined,
): void {
  if (!registration) return
  const urls = [...VERCEL_BLOB_PRELOAD_BOOTSTRAP_GATE_URLS]
  const post = (sw: ServiceWorker | null) => {
    try {
      sw?.postMessage({ type: ECLIPSERA_PRECACHE_BLOB_GATE_MSG, urls })
    } catch {
      /* ignore */
    }
  }
  post(registration.active)
  post(registration.waiting)
  post(registration.installing)
}
